import { QueryClient } from '@tanstack/react-query';

// React Query 기본 설정
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // 윈도우 포커스 시 자동 리패치 비활성화
      retry: 1, // 실패 시 1번만 재시도
      staleTime: 5 * 60 * 1000, // 5분간 데이터를 fresh로 유지
      gcTime: 10 * 60 * 1000, // 10분간 캐시 유지 (이전 cacheTime)
    },
  },
});
